module.exports = __webpack_public_path__ + "img/bg-new-3.ccd9b577.png";